export enum ContentPageEnum {
  HOME = 1,
  STATIC_PAGE = 2,
  HOME_PUBLIC = 4,
}

export enum PageComponentEnum {
  TEXT = 1,
  CAROUSEL = 2,
  BANNER = 3,
  LINKED_IMAGE = 4,
  TRAINING = 5,
  WYS = 6,
  REDEEM_POINTS = 7,
  GRID = 8,
  USER_POINTS = 10,
  SCAN_CTA = 11,
  REGISTER_SECTION = 12,
  FAQ = 13,
  PRODUCT_SECTION = 47,
  VIDEO = 48,
  FORMATION = 91,
  TALK = 92,
  CAMPAIGN = 93,
  ANNUAL_CAMPAIGN = 94,
  EXPERIENCE = 95,
  FORMATION_CON = 910,
}

export enum PageDetailEnum {
  IMAGE = 1,
  VIDEO = 2,
  TEXT = 3,
  LINK = 4,
  ICON = 5,
  WYSWYG = 6,
  PRODUCT = 7,
  PRODUCT_ITEM = 8,
  USER_POINTS = 10,
  FAQ_ITEM = 11,
}

export enum PageDetailLinkedImage {
  FULL = 0,
  LEFT = 1,
  RIGHT = 2,
}
